import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap, switchMap } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { SearchResultModel } from '../../models/query/search-result-model';
import { MyfileApiService } from '../myfile-api.service';
import { BaseListService } from './base-list.service';
import { TaskModel } from '../../models/task/task.model';
import { StrategyType } from '../../enums/strategy-type-enum';
import { ImportEntitySearch } from '../../models/import/import-entity-search.model';
import { EntityTypeEnum } from '../../enums/entity-type-id-enum';

@Injectable({
  providedIn: 'root'
})

export class ImportEntitiesListService extends BaseListService {

  defaultInvoiceListState: ImportEntitySearch = {
      sortColumnDirective: '',
      sortDirectionDirective: '',
      pageSize: GlobalComponent.defaultPagingInfo.pageSize,
      pageIndex: 0,
      startIndex: 0,
      sortColumn: '',
      sortDirection: '',
      searchTerm: undefined,
      ids: []
      
  };

  private _resultItems$ = new BehaviorSubject<TaskModel[]>([]);
  protected override _state: ImportEntitySearch = { ...this.defaultInvoiceListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  set createdById(createdById: any) { this._state.createdById = createdById; }
  set strategyType(strategyType: StrategyType) {this._set({ strategyType });}
  set taskId(taskId: string) {this._set({ taskId });}
  set isProcessed(isProcessed: boolean) {this._set({ isProcessed });}
  set finiteStateMachineId(finiteStateMachineId: string) {this._set({ finiteStateMachineId });}
  set entityType(entityType:EntityTypeEnum|undefined) { this._set({entityType}) }

  protected _search(): Observable<SearchResultModel<TaskModel> | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getImportEntities(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultInvoiceListState };
    this._resultItems$.next(new Array<TaskModel>());
    this._total$.next(0);
  }
}